import React from 'react';
import { MapPin, Phone, Mail, MessageCircle, ExternalLink } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { contactInfo, branding } from '../data/mock';

const Footer = () => {
  const { t } = useLanguage();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* About */}
          <div className="space-y-4">
            <div className="bg-white p-3 rounded-lg inline-block">
              <img 
                src={branding.logo} 
                alt="CleanRide Rental Logo" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm">
              {t.footer.aboutText}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">{t.footer.quickLinks}</h4>
            <ul className="space-y-2">
              {Object.entries(t.nav).map(([key, value]) => (
                <li key={key}>
                  <button
                    onClick={() => scrollToSection(key)}
                    className="text-gray-400 hover:text-[#FF8C00] transition-colors text-sm"
                  >
                    {value}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">{t.footer.contactInfo}</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Phone className="w-4 h-4 text-[#0077FF] mt-1 flex-shrink-0" />
                <a href={`tel:${contactInfo.phone}`} className="text-gray-400 hover:text-[#FF8C00] transition-colors text-sm">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="w-4 h-4 text-[#0077FF] mt-1 flex-shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="text-gray-400 hover:text-[#FF8C00] transition-colors text-sm">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 text-[#0077FF] mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">
                  {contactInfo.address}
                </span>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">{t.footer.followUs}</h4>
            <div className="space-y-3">
              <a
                href={`https://wa.me/${contactInfo.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 bg-[#25D366] hover:bg-[#20BA5A] p-3 rounded-lg transition-colors group"
              >
                <MessageCircle className="w-5 h-5 text-white" />
                <span className="text-white font-medium">WhatsApp</span>
              </a>
              <a
                href={contactInfo.googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 bg-[#0077FF] hover:bg-[#0055CC] p-3 rounded-lg transition-colors group"
              >
                <ExternalLink className="w-5 h-5 text-white" />
                <span className="text-white font-medium">Google Maps</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              {t.footer.copyright}
            </p>
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-[#FF8C00] transition-colors">
                Conditions d'utilisation
              </a>
              <a href="#" className="hover:text-[#FF8C00] transition-colors">
                Confidentialité
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
